"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _buoyTheme = require("buoy-theme");

var _buoyTheme2 = _interopRequireDefault(_buoyTheme);

var _IconContainer = require("./IconContainer");

var _IconContainer2 = _interopRequireDefault(_IconContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var LocationIcon = function LocationIcon(_ref) {
  var props = _objectWithoutProperties(_ref, []);

  return _react2.default.createElement(
    _IconContainer2.default,
    props,
    _react2.default.createElement(
      "svg",
      {
        width: "16px",
        height: "18px",
        viewBox: "0 0 16 18",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      },
      _react2.default.createElement(
        "title",
        null,
        "Group 15 Copy 3"
      ),
      _react2.default.createElement(
        "desc",
        null,
        "Created with Sketch."
      ),
      _react2.default.createElement(
        "g",
        {
          id: "190716-V2",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        },
        _react2.default.createElement(
          "g",
          {
            id: "190723_NYT-dashboard-unauth",
            transform: "translate(-107.000000, -1485.000000)",
            stroke: _buoyTheme2.default.colors[props.color]
          },
          _react2.default.createElement(
            "g",
            {
              id: "Group-15-Copy-3",
              transform: "translate(108.000000, 1485.000000)"
            },
            _react2.default.createElement(
              "g",
              {
                id: "smartphone",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1.5"
              },
              _react2.default.createElement("rect", {
                id: "Rectangle-path",
                x: "0",
                y: "0.846153846",
                width: "10",
                height: "16"
              })
            ),
            _react2.default.createElement("rect", {
              id: "Rectangle-path",
              strokeWidth: "1.5",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              x: "2.88461538",
              y: "12.0384615",
              width: "4.03846154",
              height: "4.61538462"
            }),
            _react2.default.createElement("path", {
              d: "M2.59615385,8.07692308 L7.21153846,8.07692308",
              id: "Line-4",
              strokeWidth: "1.25",
              strokeLinecap: "round"
            }),
            _react2.default.createElement("path", {
              d: "M2.59615385,6 L7.21153846,6",
              id: "Line-4-Copy-2",
              strokeWidth: "1.25",
              strokeLinecap: "round"
            }),
            _react2.default.createElement("path", {
              d: "M2.59615385,4 L7.21153846,4",
              id: "Line-4-Copy-3",
              strokeWidth: "1.25",
              strokeLinecap: "round"
            }),
            _react2.default.createElement("rect", {
              id: "Rectangle",
              strokeWidth: "1.5",
              strokeLinejoin: "round",
              x: "10.0961538",
              y: "8.75",
              width: "4",
              height: "8.07692308"
            })
          )
        )
      )
    )
  );
};

LocationIcon.defaultProps = {
  color: "neutralDark"
};

exports.default = LocationIcon;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-icons/dist/icons/LocationIcon.js
// module id = 423
// module chunks = 168707334958949